// .{8,} Asserts that the entire string is a composition of at least 8 "anything, except new line".
// (?=.*[a-z]) use positive look ahead to see if at least one lower case letter exists
// (?=.*[A-Z]) use positive look ahead to see if at least one upper case letter exists
// (?=.*\d) use positive look ahead to see if at least one digit exists
export const PASSWORD_VALIDATION_REGEX = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/
export const INTL_ID_VALIDATION_REQUIREMENTS = 'validation.password.requirements'
